export default "__VITE_ASSET__BgeN9Gey__"